module.exports = __webpack_public_path__ + "static/media/aboutusvideo.016fd77c.mp4";